import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import NCR from "./ncr";
import SOP from "./sop";
import Checklist from "./checklist";
import JobMethodology from "./jobmethodology";
import LogObseravation from "./log-observation";
import LogIncident from "./log-incident";
import SafetySOP from "./safety-sop-records";
import JobSpecificTraining from "./job-specific-training";
import Concequences from "./consequences";
import Toolbox from "./toolbox";
import WorkPermit from "./work-permit";
export default function QualityRecord({ project }) {
  return (
    <React.Fragment>
      <Tabs>
        <div className="row" id="risk-register">
          <div className="col-12">
            <TabList>
              <Tab>Log Observation</Tab>
              <Tab>Log Incident</Tab>
              {/* <Tab>Safety Sop</Tab> */}
              <Tab>Job Specific Training</Tab>
              <Tab>Concequences</Tab>
              <Tab>Toolbox Talk</Tab>
              <Tab>Work Permit</Tab>
            </TabList>
          </div>
          {/* <hr /> */}
        </div>
        <div className="row" style={{ marginLeft: 0 }}>
          <TabPanel>
            <LogObseravation project={project} />
          </TabPanel>
          <TabPanel>
            <LogIncident project={project} />
          </TabPanel>
          {/* <TabPanel>
            <SafetySOP project={project} />
          </TabPanel> */}
          <TabPanel>
            <JobSpecificTraining project={project} />
          </TabPanel>
          <TabPanel>
            <Concequences project={project} />
          </TabPanel>
          <TabPanel>
            <Toolbox project={project} />
          </TabPanel>
          <TabPanel>
            <WorkPermit project={project} />
          </TabPanel>
        </div>
      </Tabs>
    </React.Fragment>
  );
}
